module.exports = __webpack_public_path__ + "static/media/lor.8cbe6de8.png";